export default "__VITE_ASSET__CAKA50k1__"